import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import Landing from './pages/Landing'
import Snapshot from './pages/Snapshot'
import Checkout from './pages/Checkout'
import Report from './pages/Report'
import Login from './pages/Login'
import Register from './pages/Register'
import SetupTFA from './pages/SetupTFA'
import Dashboard from './pages/Dashboard'
import Admin from './pages/Admin'
import SubjectIntake from './pages/SubjectIntake'
import OptOutDashboard from './pages/OptOutDashboard'
import SampleReport from './pages/SampleReport'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Enterprise from './pages/Enterprise'
import TorIndexOps from './pages/TorIndexOps'
import DarkWebSearch from './pages/DarkWebSearch'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/snapshot/:id" element={<Snapshot />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/enterprise" element={<Enterprise />} />

        {/* TFA setup - requires auth but not TFA yet */}
        <Route path="/setup-tfa" element={<SetupTFA />} />

        {/* Protected routes - require auth + TFA */}
        <Route path="/checkout/:tier" element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        } />
        <Route path="/report/:id" element={
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        } />
        <Route path="/intake/:orderId" element={
          <ProtectedRoute>
            <SubjectIntake />
          </ProtectedRoute>
        } />
        <Route path="/optouts" element={
          <ProtectedRoute>
            <OptOutDashboard />
          </ProtectedRoute>
        } />
        <Route path="/sample-report" element={
          <ProtectedRoute>
            <SampleReport />
          </ProtectedRoute>
        } />
        <Route path="/tor-index" element={
          <ProtectedRoute>
            <TorIndexOps />
          </ProtectedRoute>
        } />
        <Route path="/dark-search" element={
          <ProtectedRoute>
            <DarkWebSearch />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  )
}

export default App
